<style scoped>
.img-ar {
    width: 100%;
    position: relative;
    overflow: hidden;
    transition: padding-bottom 0.7s ease-in-out;
}
.img-ar > img {
    position: absolute;
    top: 50%;
    left: 50%;
    max-height: 100%;
    max-width: 100%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.img-ar.fill-full-width > img {
    max-height: none;
    width: 100%;
}
</style>

<template>
    <div
        class="img-ar"
        :class="{ 'bg-transparent': loaded, 'bg-gray-100': !loaded }"
        :style="{
            'padding-bottom': 100 / (fillImgHeight ? srcRatio : ratio) + '%'
        }"
    >
        <img
            :src="src"
            @load="
                e => {
                    loaded = true;
                    $emit('loaded');
                    if (fillImgHeight) {
                        srcRatio =
                            e.currentTarget.naturalWidth /
                            e.currentTarget.naturalHeight;
                    }
                }
            "
            :alt="alt"
            v-on:error.once="
                e => {
                    e.currentTarget.src = srcError;
                    $emit('loadError');
                }
            "
        />
    </div>
</template>

<script>
import img3s112 from '../assets/img/3-112.png';
export default {
    props: {
        src: { type: String, required: true },
        srcError: { type: String, default: img3s112 },
        alt: {},
        ratio: { default: 1 },
        fillImgHeight: { type: Boolean, default: false }
    },
    data: () => ({ loaded: false, srcRatio: undefined })
};
</script>
